import React, { useState } from 'react';

import { Button } from '@apigrowfinance/pbolt-button';
import { Card } from '@apigrowfinance/pbolt-card';
import { InactiveUser } from '@apigrowfinance/pbolt-icons';
import IllustratedMessage from '@apigrowfinance/pbolt-illustrated-message';
import { Restricted } from '@apigrowfinance/pbolt-permission-provider';
import { FormattedMessage } from 'react-intl';
import { useParams } from 'react-router-dom';

import LoadingErrorMessage from '@components/LoadingErrorMessage/LoadingErrorMessage';
import AddNewLocation from '@components/locations/AddNewLocation';
import useGetAddresses from '@hooks/queries/useGetAddresses';
import Locations from '@pages/accountDetail/tabs/locations/Locations';

const LocationsController = () => {
    const { accountId } = useParams();
    const {
        data: locations,
        isLoading,
        isError,
        refetch: refetchLocationDetails,
    } = useGetAddresses(accountId);

    const [addNewLocationOpen, setAddNewLocationOpen] = useState(false);

    const handleAddClick = () => setAddNewLocationOpen(true);

    if (isError) {
        return (
            <Card isTopRadiusBorder={false}>
                <LoadingErrorMessage />
            </Card>
        );
    }

    return (
        <>
            {locations?.length == 0 && !isLoading ? (
                <Card isTopRadiusBorder={false}>
                    <IllustratedMessage
                        icon={<InactiveUser color="inherit" />}
                        messageMain={
                            <FormattedMessage
                                id="Locations.noLocationsToShow"
                                defaultMessage="No locations to show"
                            />
                        }
                        messageSub={
                            <FormattedMessage
                                id="Locations.thereHaveBeenNoLocationsAdded"
                                defaultMessage="There have been no locations added"
                            />
                        }
                        callToAction={
                            <Restricted to="create.location">
                                <Button onClick={handleAddClick}>
                                    <FormattedMessage
                                        id="Locations.addLocationCallToAction"
                                        defaultMessage="Add location"
                                    />
                                </Button>
                            </Restricted>
                        }
                    />
                </Card>
            ) : (
                <Locations
                    isLoading={isLoading}
                    locations={locations}
                    openAddLocationModal={handleAddClick}
                    refetch={refetchLocationDetails}
                />
            )}
            {addNewLocationOpen && (
                <AddNewLocation
                    setAddNewLocationOpen={setAddNewLocationOpen}
                    addNewLocationOpen={addNewLocationOpen}
                    refetch={refetchLocationDetails}
                />
            )}
        </>
    );
};
export default LocationsController;
